import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { ManagerPayersScreen } from '../features/manager-payers/ManagerPayersScreen'

export const Route = createFileRoute('/manager-payers')({
  component: () => <RequireAuth><ManagerPayersScreen /></RequireAuth>,
})
